import { NotificationViewModel } from '../../../../common/model/notification/notificationViewModel';
import { createDataFetchSlice } from '../../../utils/dataFetch';


export const adminNotificationsListSlice = createDataFetchSlice<
    NotificationViewModel[]
>({ name: 'list' });
